// Bozza del pannello «In quali centri vuoi cercare?»: id dei centri aggiunti all'origin.
// L'origin (centro scelto nello step "dove") è sempre incluso e non fa parte della bozza.

export interface DraftApplyResult {
  addedIds: string[];
  // il centro corrente non è più incluso: l'appuntamento torna all'origin
  isReturningToOrigin: boolean;
}

// Aggiunti validi: senza l'origin, senza id vuoti né doppioni, al massimo max nell'ordine
// in cui il cliente li ha scelti
export const sanitizeAddedPointOfSaleIds = (
  ids: string[],
  originId: string,
  max: number
): string[] =>
  Array.from(new Set(ids.filter((id) => id !== '' && id !== originId))).slice(
    0,
    Math.max(max, 0)
  );

// Tocco su una scheda: toglie il centro se è già scelto, altrimenti lo aggiunge finché
// c'è posto; raggiunto il massimo la bozza non cambia
export const toggleDraftPointOfSaleId = (
  draft: string[],
  id: string,
  max: number
): string[] => {
  if (draft.includes(id)) return draft.filter((item) => item !== id);
  if (draft.length >= max) return draft;
  return [...draft, id];
};

// Esito della bozza confermata: gli aggiunti da salvare e se il centro corrente ne esce
export const resolveDraftApply = (
  draft: string[],
  originId: string,
  currentId: string,
  max: number
): DraftApplyResult => {
  const addedIds = sanitizeAddedPointOfSaleIds(draft, originId, max);
  return {
    addedIds,
    isReturningToOrigin: currentId !== originId && !addedIds.includes(currentId),
  };
};

// Schede visibili all'apertura del pannello: la prima pagina, allungata fino all'ultimo
// centro già scelto, così nessuna scelta resta nascosta sotto «Mostra altri centri»
export const getInitialVisibleCount = (
  candidateIds: string[],
  selectedIds: string[],
  pageSize: number
): number => {
  const lastSelectedIndex = candidateIds.reduce(
    (last, id, index) => (selectedIds.includes(id) ? index : last),
    -1
  );
  return Math.max(pageSize, lastSelectedIndex + 1);
};
